import React, { JSX, useContext, useMemo } from 'react'
import { Box, BoxProps, Grid } from '@chakra-ui/react'
import { getDay, getDaysInMonth } from 'date-fns'

import { DateTimePickerContext } from 'components/form/DateTimePicker/helpers'

import { Day } from './components/Day'
import { Header } from './components/Header'
import { WeekDays } from './components/WeekDays'

export const DatePicker = ({ ...boxProps }: BoxProps): JSX.Element => {
  const { dateTimeState } = useContext(DateTimePickerContext)

  const { month, year } = dateTimeState.datePicker

  const daysInMonth = useMemo(() => getDaysInMonth(new Date(year, month, 1)), [month, year])
  const weekOffset = useMemo(() => getDay(new Date(year, month, 1)) - 1, [month, year])

  return (
    <Box {...boxProps}>
      <Header />
      <WeekDays />
      <Grid templateColumns="repeat(7, auto)" gap="8px 0" justifyContent="space-between">
        {[...Array(weekOffset === -1 ? 6 : weekOffset)].map((_, index) => (
          <Box key={`offset-${index}`} textAlign="center" fontSize="sm" />
        ))}
        {[...Array(daysInMonth)].map((_, index) => (
          <Day key={`${year}-${month}-${index}`} index={index} />
        ))}
      </Grid>
    </Box>
  )
}
